import { Line, Section, Word } from '../../types'

class Buffer {
  buffer: string[]
  index: number
  separator: string
  constructor(separator: string) {
    // TODO: add size initializer?
    this.buffer = []
    this.index = 0
    this.separator = separator ? separator : ''
  }
  append(str: string) {
    this.buffer[this.index] = str
    this.index++
  }

  toString() {
    return this.buffer.join(this.separator)
  }
}
class LyricPrintToCsvVisitor {
  _lineBuffer: Buffer | null
  constructor() {
    this._lineBuffer = null
  }
  get lineBuffer(): Buffer {
    if (!this._lineBuffer) {
      throw new Error('lineBuffer not initialized')
    }
    return this._lineBuffer
  }
  toString() {
    return this.lineBuffer.toString()
  }

  startTrack() {
    this._lineBuffer = new Buffer('\n')
  }

  endTrack() {}

  startSection(section: Section) {}

  endSection() {}

  startLine() {}

  endLine() {}

  visitWord(word: Word, line: Line, section: Section) {
    const text = `${word.label.replace(',', '')},${word.time || 0}`
    this.lineBuffer.append(text)
  }
}

export default LyricPrintToCsvVisitor
